export default __webpack_public_path__ + "static/mic-maps-logo-969f31e3d8c36353aaab092a8ad7e876.png";